<template>
  <section class="w store-list--w">
    <div class="store-list--body">
      <div class="store-item" v-for="(item, i) in storeList" :key="i">
        <div
          v-if="isOpenReplacement || isSelfPhoto"
          style="padding-right: 0.24rem"
        >
          <checkbox
            :checked="item.checked"
            :uid="item.storeId"
            @onChange="onChange"
          />
        </div>
        <div class="store-item-left">
          <a
            class="store-item--name elps"
            :href="'//life.cekid.com/h5/shop?businessId=' + item.businessKey"
          >
            {{ item.storeName }}
          </a>
          <div class="store-item--middle" @click="goMap(item)">
            <i class="icon-position"></i>
            <div class="store-item--content">
              <p class="store-item--address elps">
                {{ item.addressStreet }}
              </p>
              <p class="store-item--distance" v-if="isAuthorizedPosition">
                距您&nbsp;{{ item.distanceKm }}
              </p>
            </div>
          </div>
        </div>
        <a @click="callPhone(item)"><i class="icon-call"></i></a>
      </div>
    </div>
  </section>
</template>

<script>
import checkbox from '../../checkbox'
import { isEmptyObject, isNullOrEmpty } from '@/utils'
import { STORAGE_NAME_POSITION } from '../constants'
import { goMapRouter } from '../lib/map'
export default {
  name: 'shopList',
  components: {
    checkbox
  },
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    isOpenReplacement: {
      type: Boolean,
      default: false
    },
    isSelfPhoto: {
      type: Boolean,
      default: false
    },
    selectedStoreId: {
      type: Number,
      default: null
    }
  },
  data() {
    const { storeList } = this.params
    storeList.forEach(x => {
      const { distance } = x
      if (+distance > 6e4) {
        x.distanceKm = '>60km'
      }
      if (this.isOpenReplacement) {
        // this.$set(x, "checked", x.storeId === this.selectedStoreId);
        x.checked = x.storeId === this.selectedStoreId
      }
    })
    return {
      /**@type import('../services').storeInfo[]*/
      storeList,
      position: {}
    }
  },
  created() {
    const position = JSON.parse(sessionStorage.getItem(STORAGE_NAME_POSITION))
    if (this.checkPosition(position)) {
      this.position = position
    }
  },
  computed: {
    /**
     * 未授权不展示具体公里数
     */
    isAuthorizedPosition() {
      return this.checkPosition()
    }
  },
  methods: {
    checkPosition(position = this.position) {
      return !isNullOrEmpty(position) && !isEmptyObject(position)
    },
    goMap(storeInfo) {
      if (this.isSelfPhoto) {
        this.onChange({ uid: storeInfo.storeId, checked: true })
        return
      }

      goMapRouter(this, storeInfo)
    },
    callPhone(item) {
      if (this.isSelfPhoto) {
        this.onChange({ uid: item.storeId, checked: true })
        return
      }
      window.location.href = `tel:${item.mobile}`
    },
    onChange({ uid, checked }) {
      let storeInfo
      this.storeList.forEach(x => {
        if (+x.storeId === +uid) {
          if (checked) {
            storeInfo = x
          }
          x.checked = checked
        } else {
          x.checked = false
        }
      })
      // console.log(
      //   this.storeList.map((x) => {
      //     return x.checked;
      //   })
      // );
      if (!storeInfo) {
        this.$$toast('请选择服务门店')
        return
      }
      this.$emit('onChange', storeInfo)
    }
  }
}
</script>
<style lang="scss" scoped src="../style.scss"></style>
